<template>
  <ConfigProvider :locale="locale" :render-empty="renderEmpty" :get-popup-container="getPopupContainer">
    <div class="demo-app">
      <PlatformMapLayout />
      <router-view v-slot="{ Component, route }">
        <div
          class="app-route-layer"
          :class="{ 'app-route-layer--map-scene': isPersistentMapRoute(route.path) }">
          <KeepAlive :include="keepAliveRouteNames">
            <component v-if="route.meta?.keepAlive" :is="Component" />
          </KeepAlive>
          <component v-if="!route.meta?.keepAlive" :is="Component" />
        </div>
      </router-view>
    </div>
  </ConfigProvider>
  </template>
<script lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { computed, defineComponent, ref, h, KeepAlive } from 'vue'
import { useMyStore } from './store'
import { ERouterName } from './types'
// import GMap from '/@/components/GMap.vue'
import moment from 'moment'
import 'moment/dist/locale/zh-cn'
import { ConfigProvider } from 'ant-design-vue'
import PlatformMapLayout from '/@/components/platform-map/PlatformMapLayout.vue'
import { persistentMars3dMapEnabled, platformMapSceneIdFromRoutePath } from '/@/map-runtime/runtime'
moment.locale('zh-cn')

export default defineComponent({
  name: 'App',
  components: { ConfigProvider, KeepAlive, PlatformMapLayout },

  setup () {
    const store = useMyStore()
    const keepAliveRouteNames = [ERouterName.LARGE_SCREEN]
    const isPersistentMapRoute = (path: unknown) => {
      return persistentMars3dMapEnabled && platformMapSceneIdFromRoutePath(path) !== null
    }

    // 全局自定义空状态样式（使用自定义图标）
    const renderEmpty = (componentName) => {
      // 使用 import 引入图片资源，确保打包后路径正确
      return h('div', { style: { textAlign: 'center', padding: '40px 0', color: '#999' } }, [
        h('img', {
          src: new URL('./assets/my_img/home-icon/mess5.svg', import.meta.url).href, // 使用 new URL 确保打包后路径正确
          style: { marginBottom: '10px' }
        }),
        h('p', { style: { fontSize: '14px', color: 'rgba(255, 255, 255, 0.4)' } }, '暂无数据')
      ])
    }

    const getPopupContainer = (triggerNode?: HTMLElement) => {
      return triggerNode?.parentElement || document.body
    }

    return {
      locale: zhCN,
      renderEmpty,
      getPopupContainer,
      keepAliveRouteNames,
      isPersistentMapRoute
    }
  }
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}

.app-route-layer--map-scene {
  position: relative;
  z-index: 1;
  min-height: 100%;
  pointer-events: none;
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
